import { Factory } from 'rosie';
import './lib/uuid';

Factory.define('Upload')
  .attr('type', 'UPLOAD')
  .extend('Uuid');
